export default {
  data() {
    return {
      offsetTop: 0,
      marginBottom: '1rem',
      height: '100vh',
      ref: '',
    };
  },
  mounted() {
    // Top position
    this.initResizeObserver(this.element);
  },
  computed: {
    element() {
      const element = (this.ref !== '') ? this.$refs[this.ref].$el : this.$el;
      return element;
    },
    heightStyles() {
      return {
        'min-height': '180px',
        height: `calc(${this.height} - ${this.offsetTop}px - ${this.marginBottom})`,
        'max-height': `calc(${this.height} - ${this.offsetTop}px - ${this.marginBottom})`,
      };
    },
    minHeight() {
      return {
        'min-height': `calc(${this.height} - ${this.offsetTop}px - ${this.marginBottom})`,
      };
    },
  },
  methods: {
    initResizeObserver(el) {
      if (!el.tagName) {
        console.log('el', el);
        return;
      }
      const observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.contentRect) {
            this.getOffsetTop();
          }
        });
      });
      observer.observe(el);
    },
    getOffsetTop() {
      this.offsetTop = this.element.getBoundingClientRect().top;
    },
  },
};
